<template>
  <div>
    <!-- 添加项目 -->
    <el-drawer v-model="open"
               :title="title" :size="880"
               modal-class="digital_buyer-7145"
               :show-close="false"
               @open="openDrawer" @close="closeDrawer" :close-on-click-modal="false" :close-on-press-escape="false" :destroy-on-close="true">
      <div class="left-content">
        <el-form ref="formRef" :model="formData" label-position="top">
          <el-form-item label="项目分类" prop="categoryName" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
            <p style="width: 100%; height: 34px; border: 1px solid #ddd; border-radius: 3px; padding-left: 10px">
              项目信息分类/{{ formData.categoryName }}
            </p>
          </el-form-item>
          <el-form-item label="项目名称" prop="name" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
            <el-input v-model.trim="formData.name" placeholder="请输入" />
          </el-form-item>
          <el-form-item label="商品和服务税收分类编码" prop="taxCategoryCode" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
            <el-input v-model.trim="formData.taxCategoryCode" placeholder="请在右侧商品和税收分类编码项选择项目" :readonly="true" />
          </el-form-item>
          <el-form-item label="商品和服务分类简称" prop="taxCategoryName" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
            <el-input v-model.trim="formData.taxCategoryName" placeholder="请在右侧商品和税收分类编码项选择项目" :readonly="true" />
          </el-form-item>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item label="优惠政策及简易计税" prop="enjoyPrivileges">
                <el-radio-group v-model="formData.enjoyPrivileges">
                  <el-radio label="是" value="1" />
                  <el-radio label="否" value="0" />
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="优惠政策及简易计税类型" prop="enjoyPrivilegesType">
                <el-select
                  v-model="formData.enjoyPrivilegesType"
                  placeholder="请选择"
                  :empty-values="[null, undefined]"
                  :disabled="formData.enjoyPrivileges == '0'"
                >
                  <el-option label="请选择" value="" />
                  <el-option label="免税" value="1" />
                  <el-option label="优惠" value="2" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item label="是否选择普通零税率" prop="applicableRate">
                <el-radio-group v-model="formData.applicableRate">
                  <el-radio label="是" :value="1" />
                  <el-radio label="否" :value="0" />
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="税率/征收率" prop="rate" :rules="[{ required: true, message: '必填项', trigger: ['blur', 'change'] }]">
                <el-select v-model="formData.rate" placeholder="请选择" :empty-values="[null, undefined]" :disabled="formData.applicable == '1'">
                  <el-option label="请选择" value="" />
                  <el-option label="0%" :value="0" />
                  <el-option label="1%" :value="0.01" />
                  <el-option label="3%" :value="0.03" />
                  <el-option label="5%" :value="0.05" />
                  <el-option label="6%" :value="0.06" />
                  <el-option label="9%" :value="0.09" />
                  <el-option label="13%" :value="0.13" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item label="是否含税" prop="vatSign">
                <el-radio-group v-model="formData.vatSign">
                  <el-radio label="不含税" value="0" />
                  <el-radio label="含税" value="1" />
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="价格" prop="price">
                <el-input v-model="formData.price" placeholder="请输入" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item label="单位" prop="unit">
                <el-select v-model="formData.unit" placeholder="请选择" :empty-values="[null, undefined]">
                  <el-option label="请选择" value="" />
                  <el-option label="台" value="台" />
                  <el-option label="件" value="件" />
                  <el-option label="个" value="个" />
                  <el-option label="米" value="米" />
                  <el-option label="项" value="项" />
                  <el-option label="张" value="张" />
                  <el-option label="套" value="套" />
                  <el-option label="支" value="支" />
                  <el-option label="千克" value="千克" />
                  <el-option label="次" value="次" />
                  <el-option label="月" value="月" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="规格型号" prop="specification">
                <el-input v-model="formData.specification" placeholder="请输入" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="简码" prop="shortCode">
            <el-input v-model.trim="formData.shortCode" placeholder="请输入" style="width: 240px" />
          </el-form-item>
        </el-form>
      </div>
      <div class="right-content">
        <p class="right-content-title">商品和服务税收分类编码</p>
        <div class="right-wrapper">
          <p class="text">温馨提示:该系统为模拟系统,由于税收分类编码数据庞大,只显示与系统参考题目相关的数据</p>
          <div style="width: 100%; margin: 10px 0">
            <el-input v-model.trim="searchText" @keyup.enter="searchTree" placeholder="请输入数字编码/税收分类名称">
              <template #append>
                <el-button plain icon="search" @click="searchTree"></el-button>
              </template>
            </el-input>
          </div>
          <div class="tree-box">
            <el-tree v-if="!isSearch" ref="treeRef" :data="treeData" :props="defaultProps" :filter-node-method="filterNode" @node-click="nodeClick" />

            <el-scrollbar v-else>
              <ul class="search-list" v-if="searchList.length > 0">
                <li v-for="(item, index) of searchList" :key="index">
                  <span @click="nodeClick(item, { isLeaf: true })">{{ item.title }}（{{ item.taxCodeTitle }}）</span>
                </li>
              </ul>
              <p v-else class="text-empty">暂无数据</p>
            </el-scrollbar>
          </div>
        </div>
      </div>

      <template #footer>
        <el-button type="primary" @click="saveProduct">保存</el-button>
        <el-button type="default" @click="open = false">取消</el-button>
      </template>
    </el-drawer>
  </div>
</template>

<script setup>
import { treeData } from '../tree';
import useInvoiceStore from '@/store/modules/invoice';

const useInvoice = useInvoiceStore();
const props = defineProps({
  row: {
    type: Object,
    default: () => ({}),
  },
});

const emits = defineEmits(['refresh']);
const open = defineModel({ type: Boolean, default: false });
const title = ref('');

const formData = ref({});
const formRef = ref();

const defaultProps = {
  children: 'children',
  label: 'title',
};

function openDrawer() {
  title.value = props.row?.id ? '修改' : '添加';
  isSearch.value = false;
  searchText.value = '';
  searchList.value = [];
  formRef.value && formRef.value.resetFields();
  formData.value = {
    enjoyPrivileges: '0',
    applicableRate: 0,
    vatSign: '0'
  }

  nextTick(() => {
    if (props.row?.id) {
      formData.value = Object.assign({}, props.row);
    } else {
      formData.value = Object.assign({}, formData.value, props.row);
    }
  });
}

function closeDrawer() {}

function nodeClick(data, node) {
  if (!node.isLeaf) {
    return;
  }

  formData.value.taxCategoryCode = data.taxCode;
  formData.value.taxCategoryName = data.taxCodeTitle;
}

const treeRef = ref();

const isSearch = ref(false);

const searchList = ref([]);

const searchText = ref('');
function searchTree() {
  if (searchText.value) {
    searchList.value = getNode(treeData, searchText.value);
    isSearch.value = true;
  } else {
    isSearch.value = false;
    searchList.value = [];
  }

  // treeRef.value.filter(searchText.value);
}

function getNode(treeData, searchText, res = []) {
  treeData.forEach(item => {
    if (item.children && item.children.length > 0) {
      getNode(item.children, searchText, res);
    } else {
      if (item.code.includes(searchText) || item.title.includes(searchText)) {
        res.push(item);
      }
    }
  });

  return res;
}

function filterNode(value, data, node) {
  if (!value) return true;
  if (/^\d+$/.test(value)) {
    return data.code.includes(value);
  } else {
    return data.title.includes(value);
  }
}

function saveProduct() {
  formRef.value &&
    formRef.value.validate((valid) => {
      if (valid) {
        if (formData.value.id) {
          useInvoice.updateProduct(formData.value);
        } else {
          useInvoice.addProduct(formData.value);
        }
        open.value = false;
        emits('refresh');
      }
    });
}
</script>

<style lang="scss" scoped>
:deep(.el-drawer) {
  .text-empty {
    font-size: 14px;
    text-align: center;
    color: #adadad;
    line-height: 2;
  }

  .el-drawer__header {
    height: 50px;
    line-height: 50px;
    padding: 0;
    padding-left: 20px;
    margin: 0;
    border-bottom: 1px solid #eee;
  }
  .el-drawer__body {
    padding: 0;
    display: flex;
    .left-content {
      flex: none;
      width: 540px;
      height: 100%;
      padding: 18px 30px 0;
      overflow-y: auto;
    }
    .right-content {
      width: 100%;
      height: 100%;
      overflow: hidden;
      background-color: rgb(249, 250, 253);
      .right-content-title {
        margin-top: 20px;
        font-size: 18px;
        color: rgb(51, 51, 51);
        line-height: 40px;
        border-bottom: 1px solid rgb(221, 221, 221);
        padding-left: 20px;
      }
      .right-wrapper {
        box-sizing: border-box;
        width: 100%;
        height: 100%;
        margin-top: 10px;
        padding: 0 20px;
        .text {
          box-sizing: border-box;
          width: 100%;
          padding: 10px;
          border-radius: 5px;
          line-height: 22px;
          font-size: 13px;
          color: red;
          letter-spacing: 2px;
          background-color: rgb(210, 231, 251);
        }
        .tree-box {
          --el-fill-color-blank: transparent;
          height: calc(100% - 200px);
          margin-top: 15px;
          overflow: auto;
          :deep(.el-tree) {
            width: fit-content;
          }

          .search-list {
            li {
              font-size: 14px;
              cursor: pointer;
              padding: 4px 0;

              span {
                display: inline-flex;
                padding: 6px;

                &:hover {
                  background-color: #f3f3f3;
                }
              }
            }
          }
        }
      }
    }
  }

  .el-drawer__footer {
    border-top: 1px solid #eee;
    text-align: start;
  }
}
</style>

<style lang="scss">
.digital_buyer-7145 {
  pointer-events: none;
  .el-drawer {
    pointer-events: auto;
  }
  &.el-overlay {
    background-color: transparent;
  }
}
</style>
